import React from "react";
import styled from "styled-components";
import {
    contentToggleBackgroundColour, contentToggleBorderColour, contentToggleCurrentBackgroundColour,
    contentToggleHoverBackgroundColour, contentToggleLineColour, primaryTextColour
} from "../../style/styleConsts";
import {Line} from "./Line";


const Wrapper = styled.div`
    position: relative;
`;

const Toggle = styled.div`
    display: flex;
    justify-content: space-around;
    border-radius: 3px;
    border: 1px solid ${contentToggleBorderColour};
    background-color: ${contentToggleBackgroundColour};
    overflow: hidden;
    font-weight: bold;
    -webkit-font-smoothing: antialiased;
    line-height: normal;
    position: relative;
    margin: 0 auto;
`;

const Sizer = styled.div`
    margin-left: ${props => props.sideMargins};
    margin-right: ${props => props.sideMargins};
    min-width: fit-content;
`;

export const Item = styled.div`
    border: 1px solid transparent;
    border-radius: 4px;
    color: #4a4a4a;
    cursor: pointer;
    text-align: center;
    padding: 8px;
    width: 50%;
    min-width: 100px;

    ${props => props.selected ? `
        background-color: ${contentToggleCurrentBackgroundColour};
        border: 1px solid ${contentToggleLineColour};
        color: white;
    ` : `
        &:hover {
            background-color: ${contentToggleHoverBackgroundColour};
            color: ${primaryTextColour};
        }
    `}
    }
`;

export default ({current, onToggle, items, sideMargins = "0px"}) => <Wrapper>
    <Sizer sideMargins={sideMargins}>
        <Toggle>
            {items.map(item =>
                <Item
                    key={item.id}
                    className={"t-" + item.id}
                    selected={current === item.id}
                    onClick={() => onToggle(item.id)}>
                    {item.label}
                </Item>
            )}
        </Toggle>
    </Sizer>
    <Line />
</Wrapper>;